import classes from './AboveFold.module.scss'

export const AboveFold = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.bg}></div>
      <div className={`ds-u-position--relative ds-u-padding-top--3 ds-u-lg-padding-top--7`}>
        {children}
      </div>
    </div>
  )
}
